<template>
  <modal
    :title="
      pricePackage.objKey ? 'Edit Package' : 'Add New Package'
    "
    ref="newPriceModal"
    size="modal-lg"
    @save="savePrice()"
  >
    <div class="row">
      <div class="form-group col-md-10">
        <label class="control-label"> Description </label>
        <input
          type="text"
          class="form-control"
          v-model="pricePackage.label"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-10" v-if="pricePackage.objKey">
        <label class="control-label"> Expired </label>
        <v-select :options="['true', 'false']" v-model="expired"></v-select>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/GeneralComponents/Modal";
export default {
  components: {
    Modal,
  },
  computed: {
    expired: {
      get() {
        return this.pricePackage.expired.toString();
      },
      set(expired) {
        this.pricePackage.expired = expired;
      },
    },
  },
  props: {
    pricePackage: {
      type: Object,
      required: true,
    },
  },
  methods: {
    savePrice() {
      this.$emit("save-price", this.pricePackage);
      this.$refs.newPriceModal.close();
    },
    open() {
      this.$refs.newPriceModal.open();
    },
  },
};
</script>
